import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useProduct } from "../hooks";
import { StockUnitsList } from "../../stock-units/components";
import { PriceRuleForm, PriceRulesList } from "../../price-rules/components";
import { GivenCansForm, GivenCansList } from "../../given-cans/components";

type IProductParams = {
  id: string;
};

export const Product: React.FC = () => {
  const { id } = useParams<IProductParams>();
  const navigate = useNavigate();
  const [priceRulesKey, setPriceRulesKey] = React.useState(0);
  const [givenCansKey, setGivenCansKey] = React.useState(0);

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useProduct(+id!);

  if (loading) return <Loading />;

  const product = data?.product?.result;

  return (
    <>
      <Header
        title="Produit"
        subtitle={product?.name}
        img={product?.imgUrl}
        buttons={[
          {
            actionText: "Ajouter des stocks",
            bgColor: "green",
            textColor: "white",
            link: `/stock-unit/create?productId=${id}`,
          },
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/product/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Nom</p>
                    <input className="input w-full" value={product?.name} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Référence</p>
                    <input className="input w-full" value={product?.reference} disabled />
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Dernier prix</p>
                    <input
                      className="input w-full"
                      value={`${((product?.lastPrice ?? 0) / 100).toFixed(2)} €`}
                      disabled
                    />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Stock total</p>
                    <input className="input w-full" value={product?.totalStock} disabled />
                  </div>
                </div>
              </div>
              <div className="w-full mt-3">
                <p className="label">Total distribué gratuitement</p>
                <input className="input w-full" value={product?.totalGiven ?? 0} disabled />
              </div>
            </div>
          </div>

          <div className="element">
            <div className="card">
              <CardHeader
                title="Lots en stock"
                button={{
                  title: "Nouvelle réception",
                  url: `/stock-unit/create?productId=${id}`,
                }}
              />
              <StockUnitsList productId={+id!} />
            </div>

            <div className="card mt-4">
              <CardHeader title="Règles de prix" />
              <PriceRuleForm
                productId={+id!}
                onCompleted={() => setPriceRulesKey((k) => k + 1)}
              />
              <div className="mt-4">
                <PriceRulesList key={priceRulesKey} productId={+id!} />
              </div>
            </div>

            <div className="card mt-4">
              <CardHeader title="Distributions gratuites" />
              <GivenCansForm
                productId={+id!}
                onCompleted={() => setGivenCansKey((k) => k + 1)}
              />
              <div className="mt-4">
                <GivenCansList key={givenCansKey} productId={+id!} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
